<template>
    <b-modal
        id="student-internship-agreement-upload-modal"
        v-model="modal"
        ref="student-internship-agreement-upload-modal"
        size="md"
        :title="$t('internship.signed_internship_agreement_upload')"
        modal-class="apprentice-default-modal student-internship-agreement-upload-modal"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')"
        :ok-title="$t('internship.upload')"
        @ok="save">
        <div v-if="uploadedFile">
            <a :href="uploadedFile.path">{{ uploadedFile.full_name }}</a>
        </div>
        <b-form-group
            class="internship-signed-agreement-file-name"
            label-for="signed-internship-name-input"
            :label="$t('internship.name_internship_agreement')">
            <b-form-input
                id="internship-name-input"
                v-model="signedInternshipAgreementNewName"
                :placeholder="$t('internship.internship_agreement_of_your_name')">
            </b-form-input>
            <br />
            <div class="internship-agreement-control">
                <div class="internship-agreement-upload">
                    <b-button
                        class="btn-upload btn-upload-banner"
                        variant="primary"
                        @click="$refs.agreementUpload.$el.childNodes[0].click()">
                        {{ $t('internship.upload_agreement') }}
                    </b-button>

                    <b-form-file
                        id="internships-agreement"
                        v-model="file"
                        v-show="false"
                        :placeholder="'file'"
                        ref="agreementUpload"
                        ><!--accept="application/pdf" -->
                    </b-form-file>
                </div>
            </div>
        </b-form-group>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-internship-student-signed-internship-agreement-upload-modal-component',
    data() {
        return {
            signedInternshipAgreementNewName: '',
            modal: false,
            uploadedFile: null,
            file: null,
            internshipId: '',
        };
    },
    methods: {
        show(internship) {
            this.uploadedFile = internship.signed_internship_agreement_for_student
                ? internship.signed_internship_agreement_for_student.file
                : null;
            this.modal = true;
            this.internshipId = internship.id;
        },

        save() {
            const formData = new FormData();
            formData.append('signedInternshipAgreementName', this.signedInternshipAgreementNewName);
            if (this.file) {
                formData.append('file', this.file);
            }

            this.alert.saving();
            axios.post(this.routes.studentSignedInternshipAgreementUpload(this.internshipId), formData).then(
                (response) => {
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped></style>
